<template>
    <div class="timeslot">
        <div class="d-flex align-items-start">
            <div class="flex-grow-1">
                <h6>{{ formattedDateRange }}</h6>
                <h2>{{ id ? (form.title ? form.title : 'Bestaand tijdblok') : 'Nieuw tijdblok' }}</h2>
            </div>

            <b-button v-if="selectedSchedule"
                class="mr-2"
                type="button"
                variant="danger"
                v-b-tooltip.hover
                title="Tijdblok verwijderen"
                @click="deleteOne"
            >
				<fa-icon v-if="!isDeletingTimeSlot" icon="trash" />
                <loader-spinner v-else iscolor="#F0F0F0" :show-spinner="true" />
			</b-button>

            <b-button type="button"
                class="mr-2"
                variant="outline-primary"
                v-b-tooltip.hover
                title="Opslaan"
                @click="selectedTime ? create() : update()"
            >
				<fa-icon v-if="!isUpdatingTimeSlot && !isCreatingTimeSlot" icon="save" />
                <loader-spinner v-else iscolor="#F0F0F0" :show-spinner="true" />
			</b-button>

            <b-button type="button"
                variant="outline-secondary"
                v-b-tooltip.hover
                title="Sluit"
                @click="$emit('close')"
            >
                <fa-icon icon="times" />
            </b-button>
        </div>
        
        <general-input
            v-model="form.title"
            label="Titel"
            placeholder="Vul een titel in"
            class="mb-2"
        />

        <general-select
            label="Type"
            placeholder="Selecteer een type afspraak"
            v-model="form.type"
            :options="typeOptions"
            class="mb-2"
        />

        <general-input
            v-model="form.max_appointments"
            inputType="number"
            label="Max. aantal afspraken"
            placeholder="10"
        />

        <div class="appointments" v-if="selectedSchedule && selectedSchedule.raw.max_appointments">
            <template v-if="!appointmentWindow">
                <div class="d-flex mb-3 mt-4">
                    <h4 class="flex-grow-1 mb-0 align-self-end">Afspraken</h4>

                    <b-button type="button"
                        v-if="!appointmentWindow"
                        size="sm"
                        variant="outline-primary"
                        v-b-tooltip.hover
                        title="Afspraak maken"
                        @click="appointmentWindow = true"
                    >
                        <fa-icon icon="plus" />
                    </b-button>
                </div>
            
                <appointment
                    v-for="appointment in appointments"
                    :key="appointment.id"
                    :appointment="appointment"
                    @deleted="$emit('update', id)"
                    class="mb-3"
                />

                <div v-if="!appointments.length" class="timeslot-appointments">
                    Er zijn nog geen afspraken gemaakt.
                </div>
            </template>

            <appointment-form v-else 
                @close="appointmentWindow = false" 
                @created="$emit('update', id)"
                :timeSlotId="id" 
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GeneralInput from '../../elements/Input/GeneralInput';
import GeneralSelect from '../../elements/Input/GeneralSelect';
import Appointment from './Appointment';
import AppointmentForm from './AppointmentForm';
import LoaderSpinner from '../../elements/LoaderSpinner';

export default {
    components: {
        GeneralInput,
        GeneralSelect,
        Appointment,
        AppointmentForm,
        LoaderSpinner
    },
    props: {
        calendarTypes: {
            type: Array,
        },

        selectedSchedule: {
            type: Object,
            default: null,
        },

        selectedTime: {
            type: Object,
            default: null,
        }
    },
    data: function () { return {
        form: {},
        appointments: [],
        id: null,
        timestamps: {},
        typeOptions: [],
        appointmentWindow: false,
    }},
    watch: {
        selectedSchedule: 'setData',
        selectedTime: 'setData'
    },
    computed: {
        ...mapGetters([
            'isUpdatingTimeSlot',
            'isDeletingTimeSlot',
            'isCreatingTimeSlot',
        ]),

        formattedDateRange: function () {
            const dmy = new Date(this.form.start).toLocaleString(this.$i18n.locale, { day: 'numeric', month: 'long', year: 'numeric' });
            const start = new Date(this.form.start).toLocaleTimeString(this.$i18n.locale, { hour: '2-digit', minute: '2-digit' });
            const end = new Date(this.form.end).toLocaleTimeString(this.$i18n.locale, { hour: '2-digit', minute: '2-digit' }); 

            return `${dmy}, ${start} - ${end}`;
        }
    },
    methods: {
        ...mapActions([
            'createTimeSlot',
            'updateTimeSlot',
            'deleteTimeSlot',
            'createAppointment',
        ]),

        async update() {
            try {
                await this.updateTimeSlot({
                    id:     this.id,
                    params: this.form
                });

                this.$emit('update', this.id);
            }
            catch (error) {
                console.log(error);
            }
        },

        async deleteOne() {
            try {
                const response = await this.deleteTimeSlot(this.id);

                this.$emit('delete');
            }
            catch (error) {
                console.log(error);
            }
        },

        async create() {
            try {
                const response = await this.createTimeSlot(this.form);

                this.$emit('update', response.id);
            }
            catch (error) {
                console.log(error);
            }
        },

        setData() {
            this.typeOptions = this.calendarTypes.map(el => ({
                value: el.id,
                label: this.capitalize(el.name),
                indicatorColor: el.bgColor,
            }));

            if (this.selectedSchedule) {
                const { appointments, created_at, updated_at, id, ...form } = this.selectedSchedule.raw;

                this.appointments = appointments;
                this.form = form;
                this.id = id;
                this.timestamps = {created_at, updated_at };
            }
            else if (this.selectedTime) {
                this.form = {
                    ...this.selectedTime,
                }
            }
        }
    },
    created () {
        this.setData();
    }
}
</script>

<style lang="scss">
.timeslot {
    &-label {
        color: black;
        font-size: 1rem;
        font-weight: 600;
        display: inline-block;
    }

    &-appointments {
        font-style: italic;
    }
}
</style>


// WEBPACK FOOTER //
// Timeslot.vue?1097feb3